import { render, staticRenderFns } from "./Diapos.vue?vue&type=template&id=5ac56644"
var script = {}
import style0 from "./Diapos.vue?vue&type=style&index=0&id=5ac56644&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports